import{h as r}from"preact";import{useState as t,useRef as e,useEffect as o}from"preact/hooks";export default(p,u,a)=>(c,f,[{C:l},m]=t({C:a||u}),n=e())=>(o(()=>(!a&&p().then(({default:r})=>(a=r,n.current||m({C:r}))),()=>n.current=1),[]),l?r(l,c):null);
//# sourceMappingURL=index.js.map
